<template>
    <b-container class="tz-container">
        <div class="tz-tab">
            <div v-for="(item,$index) in stageList" :key="$index" @click="changeStage(item.id)" :class="stageId == item.id?'stage-selected':''" >{{ item.name}}</div>
        </div>
        <div class="tz-filter-container">
            <div>
                <div class="tz-inline">赛区</div>
                <span @click="changeRegion(null)" :class=" regionId == 0?'region-selected':''" >全部</span>
                <span v-for="(item,$index) in regionList" :key="$index" @click="changeRegion(item)" :class="regionId == item.id?'region-selected':''" > {{ item.name}}</span>
            </div>
            <hr />
            <div>
                <div class="tz-inline">赛组</div>
                <span @click="changeLevel(null)" :class=" levelId == 0?'level-selected':''" >全部</span>
                <span v-for="(item,$index) in levelList" :key="$index" @click="changeLevel(item)" :class="levelId == item.id?'level-selected':''" > {{ item.name}}</span>
            </div>
        </div>
        <div>
            <div class="tz-sub-tab">
                <div :class=" rankingId ==1? 'ranking-selected':''" @click="changeType(1)">
                    <b-img src="/static/image/icon_ranking_1.png"/>
                    综合排行榜
                </div>
                <div v-if="selectStage.enableFinance" :class=" rankingId ==3? 'ranking-selected':''" @click="changeType(3)">
                     <b-img src="/static/image/icon_ranking_3.png"/>
                    证券投资赛项排行榜
                </div>
                <div v-if="selectStage.enableExam" :class=" rankingId ==2? 'ranking-selected':''" @click="changeType(2)">
                     <b-img src="/static/image/icon_ranking_2.png"/>
                    投资者教育赛项排行榜
                </div>
            </div>
        </div>
        <div class="tz-panel">
            <div class="tz-left-tab">
                <div v-if="competition.type == 1"  :class="rankingSubType==1?'ranking-sub-type-selected':''" @click="changeType2(1)" >团队排行榜</div>
                <div :class="rankingSubType==2?'ranking-sub-type-selected':''" @click="changeType2(2)" >个人排行榜</div>
                <!-- <div v-if="!isMobilePlatform" :class="rankingSubType==3?'ranking-sub-type-selected':''" @click="changeType2(3)" >大屏排行榜</div> -->
            </div>
            <div class="tz-table-container" v-if="rankingSubType == 1">
                <div class="tz-table-filter">
                    <span>检索</span><b-input v-model="queryData.kw" class="tz-filter-input" placeholder="团队名称/指导老师/院校" /> <b-button class="tz-table-button"  @click="searchRank">查询</b-button> 
                    <b-button class="tz-table-button" @click="exportTeamRank">导出</b-button>
                    <!-- <b-button class="tz-table-button">导出</b-button> -->
                </div>
                <b-container  class="tz-rank">
                    <b-row  class="table-header">
                         <b-col sm="">
                            <b-img v-if="!isMobilePlatform"  src="/static/image/icon_ranking_1.png" />
                            排名
                        </b-col>
                        <b-col sm="2">
                            <b-img v-if="!isMobilePlatform" src="/static/image/icon_rankList2_20x20.png" />
                            团队名
                        </b-col>
                        <b-col sm ="2">
                            <b-img v-if="!isMobilePlatform" src="/static/image/icon_rankList3_20x20.png" />
                            所属院校
                        </b-col>
                        <b-col s="">
                            <b-img v-if="!isMobilePlatform" src="/static/image/icon_rankList4_20x20.png" />
                            指导老师
                        </b-col>
                        <!-- <b-col v-if="selectStage.enableExam" sm="">
                            <b-img v-if="!isMobilePlatform" src="/static/image/icon_rankList5_20x20.png" />
                            投资者教育得分
                        </b-col>
                        <b-col v-if="selectStage.enableFinance" sm="">
                            <b-img v-if="!isMobilePlatform" src="/static/image/icon_rankList6_20x20.png" />
                            证券投资得分
                        </b-col>
                         <b-col v-if="selectStage.enableExam&&rankingId==2" sm="">
                            <b-img v-if="!isMobilePlatform" src="/static/image/icon_rankList5_20x20.png" />
                            投资者教育得分
                        </b-col>
                        <b-col v-if="selectStage.enableFinance&&rankingId==3" sm="">
                            <b-img v-if="!isMobilePlatform" src="/static/image/icon_rankList6_20x20.png" />
                            证券投资得分
                        </b-col> -->
                           <b-col v-if="selectStage.enableExam&&rankingId==2" sm="">
                            <b-img v-if="!isMobilePlatform" src="/static/image/icon_rankList5_20x20.png" />
                            投资者教育得分
                        </b-col>
                        <b-col v-if="selectStage.enableFinance&&rankingId==3" sm="">
                            <b-img v-if="!isMobilePlatform" src="/static/image/icon_rankList6_20x20.png" />
                            证券投资得分
                        </b-col>

                        <b-col v-if="rankingId == 1" sm="">
                            <b-img  v-if="!isMobilePlatform" src="/static/image/icon_rankList7_20x20.png" />
                            综合平均分
                        </b-col>
                        <b-col v-if="rankingId == 1" sm="">
                            <b-img v-if="!isMobilePlatform" src="/static/image/icon_rankList7_20x20.png" />
                            综合总分
                        </b-col>
                        <b-col v-if="rankingId ==2 " sm="">
                             <b-img v-if="!isMobilePlatform" src="/static/image/icon_rankList7_20x20.png" />
                             平均用时
                        </b-col>
                         <b-col v-if="rankingId == 3" sm="">
                            <b-img v-if="!isMobilePlatform" src="/static/image/icon_rankList7_20x20.png" />
                            平均累计收益率
                        </b-col>
                         <b-col v-if="rankingId == 3" sm="">
                            <b-img v-if="!isMobilePlatform" src="/static/image/icon_rankList7_20x20.png" />
                            平均年化收益率
                        </b-col>
                        <!-- <b-col sm="">
                            <b-img  v-if="!isMobilePlatform" src="/static/image/icon_rankList7_20x20.png" />
                            综合平均分
                        </b-col>
                        <b-col sm="">
                            <b-img v-if="!isMobilePlatform" src="/static/image/icon_rankList7_20x20.png" />
                            综合总分
                        </b-col> -->
                        <b-col sm>
                            <b-img v-if="!isMobilePlatform" src="/static/image/icon_rankList10_20x20.png" />
                            备注
                        </b-col>
                    </b-row>
                    <b-row v-for="(item,$index) in teamRankList" :key="$index" class="tz-rank-content">
                        <b-col sm="">
                            <span :class="'tz-rank-'+item.rank">
                                {{item.rank}}
                            </span>
                        </b-col>
                        <b-col sm="2"  style="text-align:left;">                            
                            <!-- <tz-paomadeng v-if="item.name.length>6" :content="item.name" />-->
                            <span v-if="item.name.length<=wordLen">{{item.name}}</span> 
                            <tz-tips  v-if="item.name.length>wordLen" :content="item.name" :len="wordLen"/>
                        </b-col>
                        <b-col sm ="2"  style="text-align:left;">
                            <!-- <tz-paomadeng v-if="item.school.length>6" :content="item.school" /> -->
                            <span v-if="item.school.length<=wordLen">{{item.school}}</span>
                            <tz-tips v-if="item.school.length>wordLen" :content="item.school" :len="wordLen"/>
                        </b-col>
                        <b-col sm="">
                            {{item.teacher}}
                        </b-col>
                         <b-col  v-if="selectStage.enableExam&&rankingId==2"  sm="">
                            {{numberFixed(item.examScore)}}
                        </b-col>
                        <b-col  v-if="selectStage.enableFinance&&rankingId==3" sm="">
                            {{numberFixed(item.financeScore)}}
                        </b-col>
                        <b-col v-if="rankingId == 1" sm="">
                            {{numberFixed(item.financeScore)}}
                        </b-col>
                        <b-col v-if="rankingId == 1" sm>
                            {{numberFixed(item.totalScore)}}
                        </b-col> 
                        <b-col v-if="rankingId ==2" sm="">
                            {{toSecond(item.examCostTime)}}
                        </b-col>        
                        <b-col v-if="rankingId ==3" sm="">
                            {{numberFixed(item.currentRatio)}}
                        </b-col>    
                        <b-col v-if="rankingId ==3" sm="">
                            {{numberFixed(item.yearRatio)}}
                        </b-col> 
                        <!-- <b-col  v-if="selectStage.enableExam"  sm="">
                            {{numberFixed(item.examScore)}}
                        </b-col>
                        <b-col  v-if="selectStage.enableFinance" sm="">
                            {{numberFixed(item.financeScore)}}
                        </b-col>
                        <b-col sm="">
                            {{numberFixed(item.combineScore)}}
                        </b-col>
                        <b-col sm>
                            {{numberFixed(item.totalScore)}}
                        </b-col>                         -->
                        <b-col sm @click="showMemberScore(item)">
                            <span>
                            查看
                            </span>
                        </b-col>
                    </b-row>
                </b-container>
            </div>
            <div class="tz-table-container" v-if="rankingSubType == 2">
                <div class="tz-table-filter">
                    <span>检索</span><b-input v-model.trim="queryData.kw" class="tz-filter-input" placeholder="姓名/学校/指导老师" /> <b-button class="tz-table-button" @click="searchRank">查询</b-button> 
                    <!-- <b-button class="tz-table-button">导出</b-button> -->
                    <b-button class="tz-table-button" @click="exportPersonalRank">导出</b-button>
                </div>
                <b-container  class="tz-rank">
                    <b-row  class="table-header">
                         <b-col sm>
                            <b-img src="/static/image/icon_ranking_1.png" />
                            排名
                        </b-col>
                        <b-col sm="2">
                            <b-img src="/static/image/icon_rankList2_20x20.png" />
                            姓名
                        </b-col>
                        <b-col sm="2">
                            <b-img src="/static/image/icon_rankList3_20x20.png" />
                            所属院校
                        </b-col>
                        <b-col sm>
                            <b-img src="/static/image/icon_rankList4_20x20.png" />
                            指导老师
                        </b-col>
                        <!-- <b-col v-if="selectStage.enableExam" sm="">
                            <b-img src="/static/image/icon_rankList5_20x20.png" />
                            投资者教育得分
                        </b-col>
                        <b-col v-if="selectStage.enableFinance" sm="">
                            <b-img src="/static/image/icon_rankList6_20x20.png" />
                            证券投资得分
                        </b-col>
                        <b-col sm="">
                            <b-img src="/static/image/icon_rankList7_20x20.png" />
                            综合得分
                        </b-col> -->
                        <b-col v-if="selectStage.enableExam&&rankingId == 2" sm="">
                            <b-img src="/static/image/icon_rankList5_20x20.png" />
                            投资者教育得分
                        </b-col>
                        <b-col v-if="selectStage.enableFinance&&rankingId == 3" sm="">
                            <b-img src="/static/image/icon_rankList6_20x20.png" />
                            证券投资得分
                        </b-col>
                        <b-col v-if="rankingId == 1" sm="">
                            <b-img src="/static/image/icon_rankList7_20x20.png" />
                            综合得分
                        </b-col>
                        <b-col v-if="rankingId == 2" sm="">
                            <b-img src="/static/image/icon_rankList7_20x20.png" />
                            用时
                        </b-col>                        
                         <b-col v-if="rankingId == 3" sm="">
                            <b-img v-if="!isMobilePlatform" src="/static/image/icon_rankList7_20x20.png" />
                            累计收益率
                        </b-col>
                         <b-col v-if="rankingId == 3" sm="">
                            <b-img v-if="!isMobilePlatform" src="/static/image/icon_rankList7_20x20.png" />
                            年化收益率
                        </b-col>


                        <!-- <b-col sm>
                            <b-img src="/static/image/icon_rankList10_20x20.png" />
                            备注
                        </b-col> -->
                    </b-row>
                    <b-row v-for="(item,$index) in rankList" :key="$index" class="tz-rank-content">
                        <b-col sm>
                            <span :class="'tz-rank-'+(item.personalRank)">
                                {{(item.personalRank)}}
                            </span>
                        </b-col>
                        <b-col sm="2" >                            
                            <!-- <tz-paomadeng v-if="item.name.length>6" :content="item.name" />-->
                            <span v-if="item.name.length<=wordLen">{{item.name}}</span> 
                            <tz-tips v-if="item.name.length>wordLen" :content="item.name" :len="wordLen"/>
                        </b-col>
                        <b-col sm ="2" style="text-align:left;">
                            <!-- <tz-paomadeng v-if="item.school.length>6" :content="item.school" /> -->
                            <span v-if="item.school.length<=wordLen">{{item.school}}</span>
                            <tz-tips  v-if="item.school.length>wordLen" :content="item.school" :len="wordLen"/>
                        </b-col>
                        <b-col  sm>
                            {{item.teacher}}
                        </b-col>
                         <b-col  v-if="selectStage.enableExam&&rankingId == 2" sm>
                                    {{numberFixed(item.examScore)}}
                         </b-col>
                         <b-col  v-if="selectStage.enableFinance&&rankingId == 3" sm>
                                {{numberFixed(item.financeScore)}}
                         </b-col>
                         <b-col v-if="rankingId == 1" sm>
                                {{item.combineScore}}
                         </b-col>                                
                         <b-col  v-if="rankingId == 2" sm>
                                {{toSecond(item.examCostTime)}}
                         </b-col>
                         <b-col v-if="rankingId ==3" sm>
                                {{numberFixed(item.currentRatio)}}
                         </b-col>    
                         <b-col v-if="rankingId ==3" sm="">
                                {{numberFixed(item.yearRatio)}}
                         </b-col>  
                        <!-- <b-col  v-if="selectStage.enableExam" sm>
                            {{numberFixed(item.examScore)}}
                        </b-col>
                        <b-col  v-if="selectStage.enableFinance" sm>
                            {{numberFixed(item.financeScore)}}
                        </b-col>
                        <b-col sm>
                            {{ numberFixed(item.combineScore)}}
                        </b-col> -->
                        <!-- <b-col sm>
                            {{item.examCostTime}}
                        </b-col> -->
                    </b-row>
                </b-container>
            </div>
            <b-container  class="tz-table-container tz-full-fixed" v-if="rankingSubType == 3 &&isFullScreen" id="fullScreen" @click="fullScreen">
                <div class="tz-full-bg">
                    <div class="tz-full-title">
                        {{competition.name}}
                    </div>
                    <div class="tz-full-content">
                            <div>
                                <div class="full-table">
                                   <div class="full-table-title">{{fullInfo.name}}</div>
                                   <div class="full-table-content">
                                      <b-container class="full-table-row">
                                          <b-row class="full-table-subtitle">
                                              <b-col sm="1">
                                                  排名  
                                              </b-col>
                                              <b-col sm="2">
                                                  队伍名称
                                              </b-col>
                                              <b-col sm="1">
                                                  团队成员
                                              </b-col>
                                              <b-col sm="4">
                                                  所属院校
                                              </b-col>
                                              <b-col sm="1">
                                                  综合成绩
                                              </b-col>
                                              <b-col sm="2">
                                                  指导老师
                                              </b-col>
                                              <b-col sm="1">
                                                  所属赛区
                                              </b-col>
                                          </b-row>
                                          <b-row v-for="(item,$index) in fullInfo.list" :key="$index">
                                              <b-col sm="1">
                                                  {{$index+1}}
                                              </b-col>
                                              <b-col  sm="2" data-spy="scoll">
                                                  <tz-tips v-if="item.teamName.length>wordLen" :content="item.teamName" :len="wordLen"/>
                                                  <span  v-if="item.teamName.length<=wordLen" > {{item.teamName}}</span>
                                              </b-col>
                                              <b-col sm="1">
                                                <tz-tips v-if="item.name.length>wordLen" :content="item.name" :len="wordLen"/>
                                                <span  v-if="item.name.length<=wordLen" >{{item.name}}</span>
                                              </b-col>
                                              <b-col  sm="4">
                                                  <tz-tips v-if="item.school.length>wordLen" :content="item.name" :len="wordLen"/>
                                                  <span v-if="item.school.length<=wordLen"> {{item.school}}</span>                                                 
                                              </b-col>
                                              <b-col  sm="1">
                                                  {{numberFixed(item.combineScore)}}
                                              </b-col>
        
                                              <b-col sm="2">
                                                  {{item.teacher}}
                                              </b-col>
                                              <b-col sm="1">
                                                  {{idToRegion(item.provinceId)}}
                                              </b-col>
                                          </b-row>
                                         
                                      </b-container>
                                   </div>
                                </div>
                                <div class="full-table">
                                   <div class="full-table-title">{{fullInfo.name2}}</div>
                                   <div class="full-table-content">
                                      <b-container class="full-table-row">
                                          <b-row class="full-table-subtitle">
                                              <b-col sm="1">
                                                  排名
                                              </b-col>
                                              <b-col sm="2">
                                                  队伍名称
                                              </b-col>
                                              <b-col sm="1">
                                                  团队成员
                                              </b-col>
                                              <b-col sm="4">
                                                  所属院校
                                              </b-col>
                                              <b-col sm="1">
                                                  综合成绩
                                              </b-col>
                                              <b-col sm="2">
                                                  指导老师
                                              </b-col>
                                              <b-col sm="1">
                                                  所属赛区
                                              </b-col>
                                          </b-row>
                                          <b-row v-for="(item,$index) in fullInfo.list2" :key="$index">
                                              <b-col sm="1">
                                                  {{$index+1}}
                                              </b-col>
                                              <b-col  sm="2" data-spy="scoll">
                                                  <tz-tips v-if="item.teamName.length>wordLen" :content="item.teamName" :len.sync="wordLen"/>
                                                  <span  v-if="item.teamName.length<=wordLen" > {{item.teamName}}</span>
                                              </b-col>
                                              <b-col sm="1">
                                                <tz-tips v-if="item.name.length>wordLen" :content="item.name" :len.sync="wordLen"/>
                                                <span  v-if="item.name.length<=wordLen" >{{item.name}}</span>
                                              </b-col>
                                              <b-col  sm="4">
                                                  <tz-tips v-if="item.school.length>wordLen" :content="item.name" :len.sync="wordLen"/>
                                                  <span v-if="item.school.length<=wordLen"> {{item.school}}</span>                                                 
                                              </b-col>
                                              <b-col  sm="1">
                                                  {{numberFixed(item.combineScore)}}
                                              </b-col>
        
                                              <b-col sm="2">
                                                  {{item.teacher}}
                                              </b-col>
                                              <b-col sm="1">
                                                  {{idToRegion(item.provinceId)}}
                                              </b-col>
                                          </b-row>
                                         
                                      </b-container>
                                   </div>
                                </div>
                            </div>
                            <div>
                                <div class="tz-full-team1">
                                    <div>{{fullInfo.teamCount}}</div>
                                    <div>参赛队伍</div>
                                </div>
                                <div class="tz-full-team2">
                                    <div>{{fullInfo.memberCount}}</div>
                                    <div>参赛人员</div>
                                </div>
                                <div class="tz-full-team3">
                                    <div>{{fullInfo.schoolCount}}</div>
                                    <div>覆盖院校</div>
                                </div>
                            </div>
                    </div>
                </div>
            </b-container>            
        </div>
         <div class="tz-pageable">
                <span class="tz-page" @click="page(-1,1)">&lt;</span>
                <div class="tz-page-number">
                    <span @click="page(1,2)" >首页</span>
                    <span v-for="index in getPrePage()" :key="index" @click="page(index,2)" class="current-page">{{index}}</span>
            
                    <span @click="page(totalPage,2)" >尾页</span>
                </div>
                <span  class="tz-page"  @click="page(1,1)">&gt;</span>
                <span>到第</span>
                <b-input style="width:5rem; margin:0; margin-right:.5rem" type="number" v-model="queryData.pageNo" @blur="loadMemberRank" />
                <span>页</span>   
                <span>共{{queryData.total}}条/共{{this.totalPage}}页</span>
                <!-- <b-select v-model="queryData.pageSize" @change="loadMemberRank">
                    <b-select-option value="10">10条/页</b-select-option>
                    <b-select-option value="20">20条/页</b-select-option>
                    <b-select-option value="30">30条/页</b-select-option>
                </b-select>     -->
        </div>
        <div >
            <b-container class="tz-dialog" v-if="dialogVisibale">
                <b-row class="tz-dialog-header">
                    <b-col sm>
                    </b-col>
                    <b-col sm>
                        名称
                    </b-col>
                    <b-col sm>
                        证券投资得分
                    </b-col>
                    <b-col v-if="selectStage.enableExam" sm>
                        教育投资得分
                    </b-col>
                    <b-col>
                        综合得分
                    </b-col>
                    <div class="tz-dialog-close" @click="dialogVisibale = false">
                        <img  src="/static/image/dialog_close.png"/>
                    </div>
                </b-row>
                <b-row>
                     <div>
                        {{tempTeamInfo.name}} 得分详细：
                    </div>
                </b-row>
                <b-row v-for="(item,$index) in tempTeamInfo.memberList" :key="$index">
                    <b-col>
                        成员{{$index+1}}
                    </b-col>
                    <b-col>
                        {{item.name}}
                    </b-col>
                    <b-col>
                        {{numberFixed(item.financeScore)}}
                    </b-col>
                    <b-col  v-if="selectStage.enableExam" >
                        {{numberFixed(item.examScore)}}
                    </b-col>
                    <b-col>
                        {{numberFixed(item.combineScore)}}
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        平均分
                    </b-col>
                    <b-col>
                    </b-col>
                    <b-col>
                        {{numberFixed(tempTeamInfo.financeScore)}}
                    </b-col>
                    <b-col  v-if="selectStage.enableExam" >
                        {{numberFixed(tempTeamInfo.examScore)}}
                    </b-col>
                    <b-col>
                        {{numberFixed(tempTeamInfo.combineScore)}}
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </b-container>
</template>
<script>
import { getInfo } from '@/utils/auth'
import * as competitionApi from '@/api/competition'
import PaoMaDeng from '@/components/paomadeng.vue'
import Tips from '@/components/tips'
export default {
    props:{
        competition:{
            type: Object,
            default: null
        }
    },
    watch:{
        competition:function(nv){
            this.loadData()
        },
        'queryData.kw'(newValue,oldVal){
        if (newValue <= 0) {
         this.loadMemberRank(); // 当 num 小于 0 时重新请求数据
               }
        },
        //  'queryData.total'(newval,oldval){
        //     if(newval < 2){
        //         this.
        //       this.loadMemberRank();
        //     }
        //  }
    },
    data(){
        return {
            userInfo: null,
            stageId: 0,
            selectStage: null,
            regionId:0,
            levelId: 0,
            rankingId: 1,
            rankingType: 1,
            rankingSubType:1,
            tempTeamInfo: {},
            stageList:[],
            regionList:[],
            levelList:[],
            rankList:[],
            teamRankList: [],
            dialogVisibale: false,
            isMobilePlatform: false,
            wordLen: 10,
            fullInfo:{
                name: '',
                name2: '',
                memberCount: 0,
                schoolCount: 0,
                teamCount: 0,
                list:[],
                list2:[]
            },
            queryData:{
                compId: 0,
                stageId: 0,
                pageSize: 50,
                pageNo: 1,
                pids:'',
                lids: '',
                lids2: '',
                kw: '',
                type1: 1,
                type2: 1 ,
                total: 0            
            },
            totalPage: 0,
            isFullScreen:true
        }
    },
    methods:{
        formatJson(filterVal,jsonData){
            return jsonData.map(v => filterVal.map(j => {
                if(j=== 'financeScore'||j == 'combineScore'){
                    return this.numberFixed(v[j]) 
                }
                return v[j]
            }))
        },
        exportTeamRank(){
            import('@/vendor/Export2Excel').then(excel=>{
                const tHeader = [ '排名','团队名','所属院校','指导老师','证券投资得分','综合平均分','综合总分']
                const filterVal = ['rank','name','school','teacher','financeScore','combineScore','totalScore']
                const list = this.teamRankList
                const data = this.formatJson(filterVal, list)
                excel.export_json_to_excel({
                header: tHeader,
                data,
                filename: 'team_rank',
                autoWidth: true,
                bookType: 'xlsx'
                })
            })
        },
        exportPersonalRank(){
            import('@/vendor/Export2Excel').then(excel=>{
                const tHeader = [ '排名','姓名','所属院校','指导老师','证券投资得分','综合总分']
                const filterVal = ['personalRank','name','school','teacher','financeScore','combineScore']
                const list = this.rankList
                const data = this.formatJson(filterVal, list)
                excel.export_json_to_excel({
                header: tHeader,
                data,
                filename: '个人排行',
                autoWidth: true,
                bookType: 'xlsx'
                })
            })
        },
         isMobile() {
            let flag = !!navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag;
        },
        getPrePage(){
            let rs = []
            for(var i = this.queryData.pageNo +1 ;i<this.queryData.pageNo+6;i++){
                if(i<=this.totalPage){
                    rs.push(i)
                }
            }
            return rs
        },
        showMemberScore(item){
            this.tempTeamInfo = item
            this.dialogVisibale = true
        },
        toSecond(ms){
            return (ms/1000).toFixed();
        },
        page(step,type){
            if(type ==1){
                let pn =  parseInt(this.queryData.pageNo)+parseInt(step);
                if(pn>this.totalPage){
                    pn = this.totalPage
                    return 
                }
                this.queryData.pageNo = pn 
            }else{
                this.queryData.pageNo = parseInt(step)
            }
            
            if(this.queryData.pageNo<=0){
                this.queryData.pageNo = 1
            }else{
                this.loadMemberRank()
            }
        },
        searchRank(){
            this.queryData.pageNo=1
            this.loadMemberRank()
        },
        changeType(t){
            this.rankingId =t
            this.queryData.type1 = t
            this.loadMemberRank()
        },
        numberFixed(num){
            if(typeof(num) == 'number'){
                return num.toFixed(5)
            }
            return 0
        },
        changeType2(t){
            this.rankingSubType = t
            this.queryData.type2 = t
            this.loadMemberRank()
        },
        fullScreen(){
            this.isFullScreen =true
            this.$nextTick(function(){
                 let full = document.getElementById("fullScreen")
                 this.launchIntoFullscreen(full)
            })
           
        },
        launchIntoFullscreen(element){
            if (element.requestFullscreen) {
                element.requestFullscreen()
            } else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen()
            } else if (element.webkitRequestFullscreen) {
                element.webkitRequestFullscreen()
            } else if (element.msRequestFullscreen) {
                element.msRequestFullscreen()
            }
        },
        exitFullscreen(){
            if (document.exitFullscreen) {
                document.exitFullscreen()
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen()
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen()
            }
        },
        loadMemberRank(){
            if(this.queryData.type2 == 3){
                if(this.levelList){
                    let ids = ''
                    this.fullInfo.name = this.levelList[0].name
                    this.levelList[0].catList.forEach(cat=>{
                            ids+=cat.id+","
                    })
                    if(ids.endsWith(",")){
                      ids = ids.substring(0,ids.length-1)
                    }
                    this.queryData.lids = ids
                    if(this.levelList.length>1){
                        let ids2 = ''
                        this.fullInfo.name2 = this.levelList[1].name
                        this.levelList[1].catList.forEach(cat =>{
                            ids2 +=cat.id+","
                        })
                         if(ids2.endsWith(",")){
                            ids2=  ids2.substring(0,ids2.length-1)
                          }
                        this.queryData.lids2 = ids2
                    }
                
                }
            }
            competitionApi.memberRank(this.queryData).then(res=>{
                this.queryData.total = res.data.total
                this.totalPage = Math.ceil(this.queryData.total/this.queryData.pageSize)
                if(this.queryData.type2 == 3){
                    this.fullInfo.memberCount = res.data.memberCount
                    this.fullInfo.schoolCount = res.data.schoolCount
                    this.fullInfo.teamCount = res.data.teamCount
                    this.fullInfo.list = res.data.list
                    this.fullInfo.list2 = res.data.list2
                    // this.fullScreen()
                }else{

                     this.rankList = res.data.list

                     //相对排名
                     if(!!this.queryData.kw&&this.queryData.kw.length>0){
                        
                     }else{
                          for(let i = 0;i<this.rankList.length;i++){
                            let rank =  (this.queryData.pageNo-1)*this.queryData.pageSize+i+1
                            this.rankList[i].personalRank = rank
                         }
                     }

                    if(this.queryData.type2 == 1){
                        this.convertTeamRank()
                    }
                }
               
            })
        },
        changeStage(id){
            this.stageId = id
            let sl = this.stageList.filter(item=> item.id == id)
            if(!!sl&&sl.length>0){
                 this.selectStage = sl[0]
            }
            this.queryData.stageId = this.stageId
            this.loadMemberRank()
        },
        convertTeamRank(){
            this.teamRankList=[]
            let idList = []
            this.rankList.forEach(item=>{
                if(idList.indexOf(item.teamId)==-1){
                    idList.push(item.teamId)
                }
            })
            for(let i = 0;i<this.queryData.pageSize;i++){
                let id = idList[i]
                let memberList =  this.rankList.filter(rank=>rank.teamId == id)
                let examScore = 0
                let financeScore = 0
                let combineScore = 0
                let currentRatio = 0
                let yearRatio = 0
                let examCostTime = 0
                memberList.forEach(m=>{
                    if(m.examScore){
                        if(typeof m.examScore === 'number'){
                            examScore+= m.examScore
                        }                        
                    }
                    if(m.financeScore){
                        if(typeof m.financeScore === 'number'){
                            financeScore+=m.financeScore
                        }  
                        
                    }
                    if(m.combineScore){
                        if(typeof m.combineScore === 'number'){
                            combineScore += m.combineScore
                        }
                    }
                     if(m.currentRatio){
                        if(typeof m.currentRatio === 'number'){
                            currentRatio += m.currentRatio
                        }
                    }
                    if(m.yearRatio){
                        if(typeof m.yearRatio === 'number'){
                            yearRatio +=m.yearRatio
                        }
                    }
                    if(m.examCostTime){
                        if(typeof m.examCostTime === 'number'){
                            examCostTime +=m.examCostTime
                        }
                    }
                })
                let tr = 0
                if(!!this.queryData.kw&&this.queryData.kw.length>0){
                    tr = memberList[0].teamRank
                }else{
                    tr =(this.queryData.pageNo-1)*this.queryData.pageSize+i+1
                }
                let teamCount = this.competition.teamMaxCount
                let rank = {
                    index: i+1,
                    rank: tr,
                    name: memberList[0].teamName,
                    school: memberList[0].school,
                    teacher: memberList[0].teacher,
                    examScore: examScore/teamCount,
                    financeScore: financeScore/teamCount,
                    combineScore: combineScore/teamCount,
                    currentRatio: currentRatio/teamCount,
                    yearRatio: yearRatio/teamCount,
                    examCostTime: examCostTime/teamCount,
                    totalScore: combineScore,
                    memberList: memberList
                }
                this.teamRankList.push(rank)
            }
  
        },
        changeRegion(item){
            if(!item){
                this.regionId = 0
                this.queryData.pids = ''
            }else{
                this.regionId = item.id
                let ids = ''
                item.catList.forEach(cat=>{
                    ids+=cat.id+","
                })
                if(ids.endsWith(",")){
                    ids = ids.substring(0,ids.length-1)
                }
                if(ids.endsWith(",")){
                    ids = ids.substring(0,ids.length-1)
                }
                this.queryData.pids = ids
            }
            this.loadMemberRank()
        },
        idToRegion(id){
            let name = '未知'
            if(this.regionList){
                this.regionList.forEach(item=>{
                    let region = item.catList.filter(cat=>cat.id == id)
                    if(region){
                        name = item.name
                    }
                })
            }
            return name
        },
        checkFull(){
            var isFull = document.fullscreenEnabled || window.fullScreen || document.webkitIsFullScreen || document.msFullscreenEnabled;          
            if (isFull === undefined) {isFull = false;}
            return isFull;
        },
        changeLevel(item){
            if(!item){
                this.levelId = 0;
                this.queryData.lids = ''
            }else{
                this.levelId = item.id
                let ids = ''
                item.catList.forEach(cat=>{
                    ids+=cat.id+","
                })
                if(ids.endsWith(",")){
                    ids = ids.substring(0,ids.length-1)
                }
                this.queryData.lids = ids
            }
            this.loadMemberRank()
        },
        loadData(){
            this.stageList = []
            if(this.competition){
                this.competition.stageList.forEach(stage=>{
                    if(this.stageId == 0){
                        this.stageId = stage.id
                        this.selectStage = stage
                    }
                    this.stageList.push({
                        id: stage.id,
                        name: stage.name
                    })
                })
            }
            competitionApi.getGroup(this.competition.id,this.stageId).then(res=>{
                console.log(res,"res");
                if(res.code == 200){
                    res.data.list.forEach(g=>{
                        if(g.limitType == 2){
                            this.regionList.push(g)
                        }else{
                            this.levelList.push(g)
                        }
                    })
                }
            })
            this.queryData.compId = this.competition.id
            this.queryData.stageId = this.stageId
            this.loadMemberRank()
        }
    },
    created(){
   
        this.isMobilePlatform = this.isMobile()
        if(this.isMobilePlatform){
            this.wordLen = 7
        }
        this.userInfo = getInfo()
        this.loadData()
    },
    mounted(){
        let that = this
        this.$nextTick(()=>{
        this.changeType2(2)
       })
        // window.addEventListener("resize",function(){
        //     if (window.outerHeight === screen.availHeight){
        //         if(window.outerWidth === screen.availWidth){
        //             that.isFullScreen = true
        //         }else{
        //             that.isFullScreen =false
        //         }
        //     }else{
        //        that.isFullScreen  = false
        //     }
        // })
    },
    components:{
        "tz-paomadeng": PaoMaDeng,
        "tz-tips": Tips
    }
}
</script>
<style scoped>

@media screen and (min-width: 375px) and (max-width: 1440px){
    .tz-container{
        max-width: unset;
    }
}
.tz-dialog-close>img{
    width: 1.5rem;
    height: 1.5rem;
    max-width: unset;
    margin: -1rem;
}
.tz-dialog-close{
    width: 1.5rem;
    right:0;
    position: absolute;
}
.tz-dialog{
    position: absolute;
    top:50%;
    left: 30%;
    background: white;
    border: 1px solid #797979;
    width: 50%;
}
.tz-dialog-header{
    background: #f2f2f2;
}
.full-table-row{
    font-size: 110%;
    text-align: center;
    color: white;
   
}
.full-table-row>div:nth-child(odd){
    background: rgba(7, 23, 71, 0.5);
     line-height: 3;
}
.full-table-row>div:nth-child(even){
    background: rgba(13, 38, 114, 0.5);
     line-height: 3;
}
.full-table-subtitle{
    color: #2efdfb;
    font-weight: bold;
     font-size: 120%;
}

.full-table-title{
    color: white;
    font-size: 180%;
    font-weight: bolder;
    margin-left: 17rem;
}
.full-table{
    background: url(/static/image/right_k_1410x407.png);
    background-size: cover;
    width: 88.125rem;
    height: 25.4375rem;
    margin-left: 5rem;
}
.tz-full-team1{
    background-image: url(/static/image/left_quan1_320x320.png);
    background-size: cover;
    color: #00ffff;
    font-size: 200%;
    font-weight: bolder;
    width: 20rem;
    height: 20rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.tz-full-team2{
    color: #f2e652;
    background-image: url(/static/image/left_quan2_320x320.png);
    background-size: cover;
    font-size: 200%;
    font-weight: bolder;
    width: 20rem;
    height: 20rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.tz-full-team3{
    color: #00b4ff;
    background-image: url(/static/image/left_quan3_320x320.png);
    background-size: cover;
    font-size: 200%;
    font-weight: bolder;
    width: 20rem;
    height: 20rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.tz-full-content{
    width: 100%;
    height:100%;
    display: flex;
}
.tz-full-content>div:nth-child(1){
    width: 80%;
    height: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}
.tz-full-content>div:nth-child(2){
    width: 20%;
    height: 90%;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    text-align: center;
    justify-content: space-around
}
.tz-full-title{
    line-height: 3;
    text-align: center;
    color: white;
    font-size: 200%;
    font-weight: bolder;
}
.tz-full-fixed{
    margin: 0;
    padding: 0;
}
.tz-full-bg{
    width: 100%;
    height: 100%;
    background-image: url(/static/image/dp_bg_1920x1080.jpg);
    background-size: cover;
}
.tz-rank-content>div{
    text-align: center;
    border-right: 1px solid #cdcdcd;
    border-bottom: 1px solid #ececec;
    line-height: 2rem;
    padding-top: .2rem;
    padding-bottom: .2rem;
    justify-content: center;
    align-items: center;
    line-height: 1;
    font-size: 80%;
}
.tz-rank-1{
    display: inline-block;
    background: #ff6600;
    color: white;
    width: 1rem;
    height: 1rem;
    border-radius: 50px;
}
.tz-rank{
    max-width: unset;
}
.tz-rank-2{
    display: inline-block;
    background: #838383;
    color: white;
    width: 1rem;
    height: 1rem;
    border-radius: 50px;
}
.tz-rank-3{
    display: inline-block;
    background: #c38a5c;
    color: white;
    width: 1rem;
    height: 1rem;
    border-radius: 50px;
}
.tz-rank>div:nth-child(2){
    background: #fee5d4;
}
.tz-rank>div:nth-child(3){
    background: #ececec;
}
.tz-rank>div:nth-child(4){
    background: #f9f3ee;
}
.tz-inline{
    display: inline-block;
    color: #7f7f7f;
}
.tz-container{
    text-align: left;
    /* max-width: unset; */
    /* max-width: 1210px; */
    margin-top: 1rem;
    padding-bottom: 3rem;
    /* display: flex;
    flex-wrap: wrap;
    justify-content: center; */
}
.tz-tab{
    display: flex;
    width: 100%;
}
.tz-sub-tab{
    display: flex;
    width: 100%;
    background-color: white;
    margin-top:1rem;
}
.tz-sub-tab div{
    font-weight: bold;
    padding:1rem;
    border-right: 1px solid #e5e5e5;
    color: #000;
}
.tz-sub-tab div:hover{
    background-color: #ff6600;
    border: none;
    color: white;
    /* filter: invert(100%); */
}
.tz-sub-tab div:hover img{
    filter: invert(100%);
}
.ranking-selected{
    background-color: #ff6600;
    color: white !important;
    border: 0;
}
.ranking-selected img{
    filter: invert(100%);
}
.tz-tab div{
    margin-right: 1rem;
    padding: .5rem;
    color: white;
    background-color: #0083eb;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding-left: 5rem;
    padding-right: 5rem;
    font-weight: bolder;
    font-size: 120%;
}
.tz-filter-container{
    background-color: white;
    padding: 1.5rem;
}
.tz-filter-container span{
    display: inline-block;
    font-weight: bold;
    margin-left: 1.5rem;
    margin-right: 1.5rem;
}

.region-selected,.level-selected{
    background-color: #ff8533;
    color: white;
}
.region-selected::before{
    border-top-left-radius: 50%;
    border-bottom-left-radius: 50%;
    content: "";
    position: absolute;
    width: 1rem;
    height: 1.5rem;
    margin-left: -1rem;
    background-color: #ff8533;
}
.region-selected::after{
    border-top-right-radius: 50%;
    border-bottom-right-radius: 50%;
    content: "";
    position: absolute;
    width: 1rem;
    height: 1.5rem;
    margin-right: -1rem;
    background-color: #ff8533;
}
.level-selected::before{
    border-top-left-radius: 50%;
    border-bottom-left-radius: 50%;
    content: "";
    position: absolute;
    width: 1rem;
    height: 1.5rem;
    margin-left: -1rem;
    background-color: #ff8533;
}

.level-selected::after{
    border-top-right-radius: 50%;
    border-bottom-right-radius: 50%;
    content: "";
    position: absolute;
    width: 1rem;
    height: 1.5rem;
    margin-right: -1rem;
    background-color: #ff8533;
}
.tz-filter-container span:hover:before{
    border-top-left-radius: 50%;
    border-bottom-left-radius: 50%;
    content: "";
    position: absolute;
    width: 1rem;
    height: 1.5rem;
    margin-left: -1rem;
    background-color: #ff8533;
}

.tz-filter-container span:hover::after{
    border-top-right-radius: 50%;
    border-bottom-right-radius: 50%;
    content: "";
    position: absolute;
    width: 1rem;
    height: 1.5rem;
    margin-right: -1rem;
    background-color: #ff8533;
}

.tz-filter-container span:hover{
    background-color: #ff8533;
    color: white;  
}
.tz-tab div:hover{
    background-color: #7223f5;
}
.stage-selected{
     background-color: #7223f5 !important;
}
.tz-panel{
    width: 100%;
    display: flex;
    min-height: 40rem;
    border-top: 1px solid #ec4822;
    background-color: white;
}
.tz-left-tab{
    background-color: #293243;
    color: white;
    line-height: 2;
    width: 9rem;
}
.tz-left-tab div{
    padding: 0.5rem;
    border-bottom:  1px solid #545b69;
    padding-left: 2rem;
    padding-right: 2rem;
    font-size: 90%;
    text-align: center;
}
.tz-left-tab div:hover{
    background-color: #000000 !important;
}
.ranking-sub-type-selected{
    background-color: #000000 !important;
}
.tz-table-container{
    background: white;
    min-height: 40rem;
    width: calc(100% - 9rem);
    max-width: unset;
}
.tz-table-filter{
    background-color: #fedac2;
    display: flex;
    justify-content: left;
    align-items: center;
    padding: .5rem;
}
.tz-table-filter span{
    display: inline-block;
    width: 3rem;
    margin-left: 1rem;
    color: black;
}
.tz-table-filter input{
    width: 15rem;
}
.b-form-btn-label-control {
    width: 15rem;
}
.tz-table-button{
    width: 5rem;
    margin-left: 1rem;
    background-color: #ff6600;
    color: white;
    border: none;
}
.table-header{
    /* display: flex;
    justify-content: space-around; */
    align-items: center;
    background: #f5f5f5;
}
.table-header div{
    border-right: 1px solid #cdcdcd;
    text-align: center;
    /* width: 20%; */
    padding: 0;
    height: 2rem;
    line-height: 2rem;
}
.table-header img{
    vertical-align: baseline;
    margin-bottom: -3px;

}
.tz-pageable{
    background-color: #202a32;
    display: flex;
    color: white;
    padding-top: .5rem;
    padding-bottom: .5rem;
    padding-left: .5rem;
    font-size: 70%;
    align-items: center;
}
.tz-page-number{
    margin-right: .5rem;
    display: flex;
    justify-content: center;
    align-items: center;
}
.tz-page-number>span{
    margin-left: 0.1rem;
}
.tz-pageable>span{
    margin-right: .5rem;
}
.current-page{
    background-color: #0263d3;
    padding: .3rem;
    border-radius: 3px;
    width: 2rem;
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/views/competition/ranking.vue